/*
 * Locks 1% of the viewport height into --da-locked-vh at load so that
 * full-viewport sections keep a fixed pixel height while iOS Chrome
 * resizes the layout viewport during toolbar show/hide on scroll.
 * Re-locks only when the viewport width changes (orientation / real
 * window resize); height-only changes come from the browser toolbars
 * and are ignored.
 */
(function () {
  if (window.__daViewportLockInit) {
    return;
  }
  window.__daViewportLockInit = true;

  var lockedWidth = 0;

  function lock() {
    lockedWidth = window.innerWidth;
    document.documentElement.style.setProperty(
      '--da-locked-vh',
      (window.innerHeight / 100) + 'px'
    );
  }

  lock();

  window.addEventListener('resize', function () {
    if (window.innerWidth !== lockedWidth) {
      lock();
    }
  }, { passive: true });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted && window.innerWidth !== lockedWidth) {
      lock();
    }
  });
})();
